import { FD100MultiSelectOptions, SDE2024MultiSelectOptionsA, SDE2024MultiSelectOptionsB, valuesToOptions } from '../../Plateforme/Utils/Listings';

function downloadCSV(csvContent, filename) {
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
}

function makePopARows(data){

    let maxNumberOfSDOAProjects = 0;
    let maxNumberOfParticipants = 0;
    for(let i=0; i<data.length; i++){
        if(data[i].participation.data?.projets?.length > maxNumberOfSDOAProjects){
            maxNumberOfSDOAProjects = data[i].participation.data.projets.length;
        }
        if(data[i].participation.participants?.length > maxNumberOfParticipants){
            maxNumberOfParticipants = data[i].participation.participants.length;
        }
    }

    var rows = []; 
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Intitulé du poste",
        "Nom de l'entreprise",
        "Raison sociale",
        "Profil",
        "À préciser",
        "Présentation de l'entreprise",
        "Document de présentation de l'entreprise",
        "Logo de l'entreprise",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Site internet",
        "Chiffre d'affaire",
        "Nombre de salariés",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "adhérent/cotisant",
        "Votre spécialité",
        "Architecture d'intérieur",
        "Donneur d'ordre, prescripiteur...",
        "Architecture d'intérieur Autre",
        "Donneur d'ordre, prescripiteur... Autre",
        "Profils de sociétés recherchées",
        "Profils de sociétés recherchées Autre",
        "Types d'offres / savoir-faire recherchés",
        "Types d'offres / savoir-faire recherchés Précisions complémentaires",
        "Types d'offres / savoir-faire recherchés Autre",
        "Votre offre, (typologie de mobiliers/objets/produits)",
        "Vos savoir-faire matériaux et techniques",
        "La place du design dans votre entreprise",
        "Participation",
    ]];

    for(let i=0; i< maxNumberOfSDOAProjects; i++){
        rows[0].push("Projet "+(i+1)+" - Description");
        rows[0].push("Projet "+(i+1)+" - Typologie(s) de mobiliers/objets/produits");
        rows[0].push("Projet "+(i+1)+" - Savoir-faire, matériaux et techniques");
        rows[0].push("Projet "+(i+1)+" - Profil du créateur recherché");
        rows[0].push("Projet "+(i+1)+" - Précision sur le profil du créateur recherché");
    }

    for(let i=0; i< maxNumberOfParticipants; i++){
        rows[0].push("Participant "+(i+1)+" - Prénom");
        rows[0].push("Participant "+(i+1)+" - Nom");
        rows[0].push("Participant "+(i+1)+" - Email");
        rows[0].push("Participant "+(i+1)+" - Téléphone portable");
        rows[0].push("Participant "+(i+1)+" - Téléphone fixe");
        rows[0].push("Participant "+(i+1)+" - Intitulé du poste");
    }

    for(var i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname,
            data[i].hsProfile.lastname,
            data[i].hsProfile.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.jobtitle,
            data[i].hsProfile.company,
            data[i].hsProfile.raison_sociale,
            data[i].hsProfile.cat_gories_via,
            data[i].hsProfile.metier_artisan_d_art,
            data[i].hsProfile.presentation_de_l_entreprise_en_francais_500_signes_,
            data[i].user.visuel ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.visuel : "",
            data[i].user.logo ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.logo : "",
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.website,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.date_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.adherent,
            data[i].participation.data?.specialite,
            data[i].participation.data?.archi,
            data[i].participation.data?.donneur,
            data[i].participation.data?.archi_autre,
            data[i].participation.data?.donneur_autre,
            data[i].participation.data?.profil,
            data[i].participation.data?.profil_autre,
            data[i].participation.data?.offre,
            data[i].participation.data?.offre_precisions,
            data[i].participation.data?.offre_autre,
            data[i].participation.data?.typologie,
            data[i].participation.data?.savoirfaire,
            data[i].participation.data?.design,
            data[i].participation.data?.presence + (data[i].participation.data?.online_precision ? (". Précision : " + data[i].participation.data?.online_precision) : ""),
        ])
        for(let j=0; j< maxNumberOfSDOAProjects; j++){
            if(!Array.isArray(data[i].participation.data?.projets)) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].participation.data?.projets[j]?.description);
            rows[i+1].push(data[i].participation.data?.projets[j]?.profil);
            rows[i+1].push(data[i].participation.data?.projets[j]?.savoirfaire);
            rows[i+1].push(data[i].participation.data?.projets[j]?.profil);
            rows[i+1].push(data[i].participation.data?.projets[j]?.precision);
        }
    
        for(let j=0; j< maxNumberOfParticipants; j++){
            if(!Array.isArray(data[i].participation.participants)) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].participation.participants[j]?.first_name);
            rows[i+1].push(data[i].participation.participants[j]?.last_name);
            rows[i+1].push(data[i].participation.participants[j]?.email);
            rows[i+1].push(data[i].participation.participants[j]?.portable);
            rows[i+1].push(data[i].participation.participants[j]?.fixe);
            rows[i+1].push(data[i].participation.participants[j]?.job_title);
        }
    }
    return rows
}

function makePopBRows(data, allCompanies){

    let maxNumberOfCandidatures = 0;
    for(let i=0; i< data.length; i++){
        if(data[i].candidatures?.length > maxNumberOfCandidatures){
            maxNumberOfCandidatures = data[i].candidatures?.length;
        }
    }

    console.log("maxNumberOfCandidatures", maxNumberOfCandidatures);

    let maxNumberOfPortfolioItems = 0;
    for(let i=0; i< data.length; i++){
        if(data[i].portfolio?.length > maxNumberOfPortfolioItems){
            maxNumberOfPortfolioItems = data[i].portfolio?.length;
        }
    }

    console.log("maxNumberOfPortfolioItems", maxNumberOfPortfolioItems);

    var rows = []; 
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Intitulé du poste",
        "Nom de l'entreprise",
        "Raison sociale",
        "Profil",
        "À préciser",
        "Présentation de l'entreprise",
        "Document de présentation de l'entreprise",
        "Logo de l'entreprise",
        "CV",
        "book/catalogue produits",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Site internet",
        "Chiffre d'affaire",
        "Nombre de salariés",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "adhérent/cotisant",

        "Sur quels types de projets travaillez-vous principalement ?",
        "Sur quels types de projets travaillez-vous principalement ? Autre",
        "En quoi votre candidature correspond aux critères recherchés pour l'événement ?",
        "Informations complémentaires",
        "Avez-vous une activité à l’international ?",
        "Avez-vous une activité à l’international ? Précisez",
    ]];

    for(let i=0; i< maxNumberOfCandidatures; i++){
        rows[0].push("Candidature "+(i+1)+" - Nom de l'entreprise");
        rows[0].push("Candidature "+(i+1)+" - Priorité");
    }

    for(let i=0; i< maxNumberOfPortfolioItems; i++){
        rows[0].push("Projet "+(i+1)+" - Titre");
        rows[0].push("Projet "+(i+1)+" - Description");
        rows[0].push("Projet "+(i+1)+" - Fichiers");
        rows[0].push("Projet "+(i+1)+" - Confidentialité");
    }

    for(var i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname || data[i].participation.data?.first_name,
            data[i].hsProfile.lastname || data[i].participation.data?.last_name,
            data[i].hsProfile.email || data[i].participation.data?.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.jobtitle,
            data[i].hsProfile.company || data[i].participation.data?.companyname,
            data[i].hsProfile.raison_sociale,
            data[i].hsProfile.cat_gories_via,
            data[i].hsProfile.metier_artisan_d_art,
            data[i].hsProfile.presentation_de_l_entreprise_en_francais_500_signes_,
            data[i].user.visuel ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.visuel : "",
            data[i].user.logo ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.logo : "",
            data[i].user.cv ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.cv : "",
            data[i].user.book ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.book : "",
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.website,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.date_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.adherent,

            data[i].participation.data?.types,
            data[i].participation.data?.types_autre,
            data[i].participation.data?.correspond,
            data[i].participation.data?.correspond_complémentaire,
            data[i].participation.data?.correspond?.includes("international") ? "Oui" : "Non",
            data[i].participation.data?.international_precision,
        ])
        for(let j=0; j< maxNumberOfCandidatures; j++){
            if(!Array.isArray(data[i].candidatures)) {
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(allCompanies.find(c => c.participation._id === data[i].candidatures[j]?.participationId)?.hsProfile.company);
            rows[i+1].push(data[i].candidatures[j]?.priorite);
        }
        for(let j=0; j< maxNumberOfPortfolioItems; j++){
            if(!Array.isArray(data[i].portfolio)) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].portfolio[j]?.title);
            rows[i+1].push(data[i].portfolio[j]?.description);
            rows[i+1].push(data[i].portfolio[j]?.files.map(file => process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+file.uploaded_path).join(', '));
            rows[i+1].push(data[i].portfolio[j]?.confidential ? "Privé" : "Public");
        }
    }
    return rows
}

function makeFDCandidatsRows_old_version(data){
    
    let maxNumberOfProjets = 0;
    for(let i=0; i< data.length; i++){
        if(data[i].participation?.data?.projets?.length > maxNumberOfProjets){
            maxNumberOfProjets = data[i].participation?.data?.projets?.length;
        }
    }

    console.log("maxNumberOfProjets", maxNumberOfProjets);

    let rows = [];
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Nom de l'entreprise",
        "Condition de participation",
        "Présentation de l'entreprise fr",
        "Présentation de l'entreprise en",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Nombre de salariés",
        "Chiffre d'affaire",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "Site internet",
        "URL facebook",
        "URL instagram",
        "URL twitter",
        "URL linkedin",
        "URL pinterest",
        "Contact de votre agence RP",
        "Portrait du ou des créateurs",
        "logo",
    ]];

    for(let i=0; i< maxNumberOfProjets; i++){
        rows[0].push("Projet "+(i+1)+" - Nom");
        rows[0].push("Projet "+(i+1)+" - Description fr");
        rows[0].push("Projet "+(i+1)+" - Description en");
        rows[0].push("Projet "+(i+1)+" - Adresse du projet");
        rows[0].push("Projet "+(i+1)+" - Awards et presse");
        rows[0].push("Projet "+(i+1)+" - Confidentialité 1");
        rows[0].push("Projet "+(i+1)+" - Confidentialité 2");
        rows[0].push("Projet "+(i+1)+" - Année du projet");
        rows[0].push("Projet "+(i+1)+" - Type de projet");
        rows[0].push("Projet "+(i+1)+" - pièce ou collection");
        rows[0].push("Projet "+(i+1)+" - Typologie");
        rows[0].push("Projet "+(i+1)+" - Typologie Autres");
        rows[0].push("Projet "+(i+1)+" - Echelle de production de votre pièce/collection");
        rows[0].push("Projet "+(i+1)+" - Nom du fabricant");
        rows[0].push("Projet "+(i+1)+" - Nom de l'éditeur");
        rows[0].push("Projet "+(i+1)+" - Nom du distributeur");
        rows[0].push("Projet "+(i+1)+" - Nom de la galerie");
        rows[0].push("Projet "+(i+1)+" - Nom de l'éditeur");
        rows[0].push("Projet "+(i+1)+" - Nom du client");
        rows[0].push("Projet "+(i+1)+" - Pays de distribution");
        rows[0].push("Projet "+(i+1)+" - Fabrication française");
        rows[0].push("Projet "+(i+1)+" - Fabrication française : précision");
        rows[0].push("Projet "+(i+1)+" - Fichiers 1");
        rows[0].push("Projet "+(i+1)+" - Crédit photo 1");
        rows[0].push("Projet "+(i+1)+" - Fichiers 2");
        rows[0].push("Projet "+(i+1)+" - Crédit photo 2");
        rows[0].push("Projet "+(i+1)+" - Fichiers 3");
        rows[0].push("Projet "+(i+1)+" - Crédit photo 3");
        rows[0].push("Projet "+(i+1)+" - Catégorie");
    }

    for(let i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname,
            data[i].hsProfile.lastname.toUpperCase(),
            data[i].hsProfile.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.company.toUpperCase(),
            data[i].participation?.data?.condition,
            data[i].hsProfile.presentation_de_l_entreprise_en_francais_500_signes_,
            data[i].participation?.data?.presentation_entreprise_anglais,
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.annee_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.website,
            data[i].hsProfile.facebook,
            data[i].hsProfile.instagram_account,
            data[i].hsProfile.twitterhandle,
            data[i].hsProfile.lien_linkedin,
            data[i].hsProfile.pinterest,
            data[i].hsProfile.email_de_votre_agence_rp,
            data[i].user.portrait ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.portrait : "",
            data[i].user.logo ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].user.logo : "",
        ])
        for(let j=0; j< maxNumberOfProjets; j++){
            if(!Array.isArray(data[i].participation?.data?.projets)) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            
            rows[i+1].push(quentinCase(data[i].participation?.data?.projets[j]?.title));
            rows[i+1].push(data[i].participation?.data?.projets[j]?.description);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.descriptionen);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.adresse);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.awards);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.confidential);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.autorisation);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.annee || "2022");
            rows[i+1].push(data[i].participation?.data?.projets[j]?.type);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.autorisation);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.typologieobjet?.split(";").map(string => string.split('_')[0]).join("; "));
            rows[i+1].push(data[i].participation?.data?.projets[j]?.autresobjet);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.echelle);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.fabricant);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.editeur);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.distributeur);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.galerie);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.editeur2);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.client);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.pays);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.fabrication);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.précisez);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.files1?.map(file => process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+file.uploaded_path).join(', '));
            rows[i+1].push(data[i].participation?.data?.projets[j]?.credit1);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.files2?.map(file => process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+file.uploaded_path).join(', '));
            rows[i+1].push(data[i].participation?.data?.projets[j]?.credit2);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.files3?.map(file => process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+file.uploaded_path).join(', '));
            rows[i+1].push(data[i].participation?.data?.projets[j]?.credit3);
            rows[i+1].push(data[i].participation?.data?.projets[j]?.categorie);
        }
    }

    return rows;
}

function makeFDCandidatsRows(data){

    console.log("data :");
    console.log(data);

    // alert('not done yet');
    // return;
    
    let maxNumberOfProjets = 0;
    let maxNumberOfFabricants = 0;
    for(let i=0; i< data.length; i++){
        const numberOfProjectsInThisParticipation = data[i].data?.projets?.length || 0;
        if(numberOfProjectsInThisParticipation > maxNumberOfProjets){
            maxNumberOfProjets = numberOfProjectsInThisParticipation;
        }

        for(let j=0; j< numberOfProjectsInThisParticipation; j++){
            const projectFabricants = data[i].data?.projets[j]?.fabricants || "[]"; // fabricants is a json encoded array
            try{
                const fabricants = JSON.parse(projectFabricants);
                if(fabricants.length > maxNumberOfFabricants){
                    maxNumberOfFabricants = fabricants.length;
                }
            }catch(e){
                console.log("Error parsing fabricants : ", projectFabricants);
                console.log("In project : ", data[i].data?.projets[j]);
                console.log("In participation : ", data[i].data);
            }
        }
    }

    console.log("maxNumberOfProjets", maxNumberOfProjets);
    console.log("maxNumberOfFabricants", maxNumberOfFabricants);

    //listings
    const partageCultureFrancaiseFD100 = FD100MultiSelectOptions.partageCultureFrancaiseFD100("fr");
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100("fr");
    const typologieAssiseFD100 = FD100MultiSelectOptions.typologieAssiseFD100("fr");
    const typologieTableFD100 = FD100MultiSelectOptions.typologieTableFD100("fr");
    const typologieLuminaireFD100 = FD100MultiSelectOptions.typologieLuminaireFD100("fr");
    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");

    let rows = [];
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone",
        "Nom de l'entreprise",
        "Condition de participation",
        "Présentation de l'entreprise fr",
        "Présentation de l'entreprise en",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Nombre de salariés",
        "Chiffre d'affaire (en euros)",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "Site internet",
        "Instagram",
        "Twitter",
        "Linkedin",
        "Contact de votre agence RP",
        "logo",
    ]];

    for(let i=0; i< maxNumberOfProjets; i++){
        rows[0].push("Projet "+(i+1)+" - Nom");
        rows[0].push("Projet "+(i+1)+" - Description fr");
        rows[0].push("Projet "+(i+1)+" - Description en");
        rows[0].push("Projet "+(i+1)+" - Awards");
        rows[0].push("Projet "+(i+1)+" - Liens presse");
        rows[0].push("Projet "+(i+1)+" - Année du projet");
        rows[0].push("Projet "+(i+1)+" - Type de projet");
        rows[0].push("Projet "+(i+1)+" - Pièce unique ou collection");
        rows[0].push("Projet "+(i+1)+" - Typologie");
        rows[0].push("Projet "+(i+1)+" - Typologie précision");
        rows[0].push("Projet "+(i+1)+" - Échelle de production");
        rows[0].push("Projet "+(i+1)+" - Nom de l'éditeur");
        rows[0].push("Projet "+(i+1)+" - Nom du distributeur");
        rows[0].push("Projet "+(i+1)+" - Pays de distribution");
        rows[0].push("Projet "+(i+1)+" - Adresse du projet");
        rows[0].push("Projet "+(i+1)+" - Fabrication française");
        rows[0].push("Projet "+(i+1)+" - Médias");
        rows[0].push("Projet "+(i+1)+" - Autorisation à communiquer sur les fabricants");
        rows[0].push("Projet "+(i+1)+" - Public dans le portfolio");
        for(let j=0; j< maxNumberOfFabricants; j++){
            rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Nom");
            rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Travail réalisé");
            rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Contact");
            rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Email");
        }
    }

    for(let i=0; i< data.length; i++){
        rows.push([
            data[i].participation?.data?.contact_prenom,
            data[i].participation?.data?.contact_nom,
            data[i].participation?.data?.contact_mail,
            data[i].participation?.data?.contact_telephone,
            data[i].hsCompany.properties?.name,
            valuesToOptions(data[i].participation?.data?.culture_francaise, partageCultureFrancaiseFD100).map(option => option.label).join(", "),
            data[i].hsCompany.properties?.description_courte_fr,
            data[i].hsCompany.properties?.description_courte_en,
            data[i].hsCompany.properties?.address,
            data[i].hsCompany.properties?.zip,
            data[i].hsCompany.properties?.city,
            data[i].hsCompany.properties?.country,
            data[i].hsCompany.properties?.numberofemployees,
            data[i].hsCompany.properties?.annualrevenue,
            data[i].hsCompany.properties?.date_de_creation_de_l_entreprise,
            data[i].hsCompany.properties?.positionnement,
            data[i].hsCompany.properties?.clientele,
            data[i].hsCompany.properties?.website,
            data[i].hsCompany.properties?.compte_instagram,
            data[i].hsCompany.properties?.twitterhandle,
            data[i].hsCompany.properties?.linkedin_company_page,
            data[i].hsCompany.properties?.email_agence_rp,
            data[i].company?.logo ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].company.logo : "",
        ])
        for(let j=0; j< maxNumberOfProjets; j++){
            if(!Array.isArray(data[i].participation?.data?.projets)) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                for(let k=0; k< maxNumberOfFabricants; k++){
                    rows[i+1].push("");
                    rows[i+1].push("");
                    rows[i+1].push("");
                    rows[i+1].push("");
                }
                continue;
            };
            
            rows[i+1].push(quentinCase(data[i].data?.projets[j]?.name));
            rows[i+1].push(data[i].data?.projets[j]?.aboutfr);
            rows[i+1].push(data[i].data?.projets[j]?.abouten);

            //awards (.awards) and press (.lien_presse) are json encoded arrays
            //awards has the fields : title and year, should be displayed as "title (year)"
            const awards = data[i].data?.projets[j]?.awards || "[]";
            try{
                const awardsArray = JSON.parse(awards);
                rows[i+1].push(awardsArray.map(award => award.title + " (" + award.year + ")").join(", "));
            }catch(e){
                console.log("Error parsing awards : ", awards);
                console.log("In project : ", data[i].data?.projets[j]);
                console.log("In participation : ", data[i].data);
            }

            //press has the fields : title and url, should be displayed as "title (url)"
            const press = data[i].data?.projets[j]?.lien_presse || "[]";
            try{
                const pressArray = JSON.parse(press);
                rows[i+1].push(pressArray.map(press => press.title + " (" + press.url + ")").join(", "));
            }catch(e){
                console.log("Error parsing press : ", press);
                console.log("In project : ", data[i].data?.projets[j]);
                console.log("In participation : ", data[i].data);
            }

            rows[i+1].push(data[i].data?.projets[j]?.year);
            rows[i+1].push(data[i].data?.projets[j]?.type);
            rows[i+1].push(data[i].data?.projets[j]?.unique_collection);

            const typologie = data[i].data?.projets[j]?.type === "objet" ? valuesToOptions(data[i].data?.projets[j]?.typologie, typologieObjetFD100).map(option => option.label).join(", ") : valuesToOptions(data[i].data?.projets[j]?.typologie, tyoplogieEspaceFD100).map(option => option.label).join(", ");
            rows[i+1].push(typologie);

            const typologiePrecisions = valuesToOptions(data[i].data?.projets[j]?.typologieAssise, typologieAssiseFD100).map(option => option.label).join(", ") ||
                                        valuesToOptions(data[i].data?.projets[j]?.typologieLuminaire, typologieLuminaireFD100).map(option => option.label).join(", ") ||
                                        valuesToOptions(data[i].data?.projets[j]?.typologieTable, typologieTableFD100).map(option => option.label).join(", ");
            rows[i+1].push(typologiePrecisions);

            rows[i+1].push(data[i].data?.projets[j]?.echelle_production);
            rows[i+1].push(data[i].data?.projets[j]?.editeur);
            rows[i+1].push(data[i].data?.projets[j]?.distributeur);
            rows[i+1].push(data[i].data?.projets[j]?.pays_distribution);
            rows[i+1].push(data[i].data?.projets[j]?.adresse);
            rows[i+1].push(data[i].data?.projets[j]?.fabrication_fr);

            //medias is an array of objects (not json this time, a real array) where the fields we care about are : fileName, path, and credit
            //we should display it as such : "fileName : path (credit : credit)" the path should be prefixed with the media base url and "userfiles/"
            const medias = data[i].data?.projets[j]?.medias || [];
            rows[i+1].push(medias.map(media => media.fileName + " : " + process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + media.path + " (crdit : " + media.credit + ")").join(", "));

            rows[i+1].push(data[i].data?.projets[j]?.communiquer_fabricants);
            rows[i+1].push(data[i].data?.projets[j]?.public ?  "Oui" : "Non");
            
            const projectFabricants = data[i].data?.projets[j]?.fabricants || "[]"; // fabricants is a json encoded array
            try{
                const fabricants = JSON.parse(projectFabricants);
                for(let k=0; k< maxNumberOfFabricants; k++){
                    if(k < fabricants.length){
                        rows[i+1].push(fabricants[k]?.name);
                        rows[i+1].push(fabricants[k]?.work);
                        rows[i+1].push(fabricants[k]?.contact);
                        rows[i+1].push(fabricants[k]?.email);
                    }else{
                        rows[i+1].push("");
                        rows[i+1].push("");
                        rows[i+1].push("");
                        rows[i+1].push("");
                    }
                }
            }catch(e){
                console.log("Error parsing fabricants : ", projectFabricants);
                console.log("In project : ", data[i].data?.projets[j]);
                console.log("In participation : ", data[i].data);
            }
        }
    }

    return rows;
}

function makeFDCandidatsRows_NEWVERSION(data){

    console.log("data :");
    console.log(data);

    //listings
    const partageCultureFrancaiseFD100 = FD100MultiSelectOptions.partageCultureFrancaiseFD100("fr");
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100("fr");
    const typologieAssiseFD100 = FD100MultiSelectOptions.typologieAssiseFD100("fr");
    const typologieTableFD100 = FD100MultiSelectOptions.typologieTableFD100("fr");
    const typologieLuminaireFD100 = FD100MultiSelectOptions.typologieLuminaireFD100("fr");
    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");

    let rows = [];
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone",
        "Nom de l'entreprise",
        "Condition de participation",
        "Présentation de l'entreprise fr",
        "Présentation de l'entreprise en",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Nombre de salariés",
        "Chiffre d'affaire (en euros)",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "Site internet",
        "Instagram",
        "Twitter",
        "Linkedin",
        "Contact de votre agence RP",
        "logo",
    ]];

    // for(let i=0; i< maxNumberOfProjets; i++){
    //     rows[0].push("Projet "+(i+1)+" - Nom");
    //     rows[0].push("Projet "+(i+1)+" - Description fr");
    //     rows[0].push("Projet "+(i+1)+" - Description en");
    //     rows[0].push("Projet "+(i+1)+" - Awards");
    //     rows[0].push("Projet "+(i+1)+" - Liens presse");
    //     rows[0].push("Projet "+(i+1)+" - Année du projet");
    //     rows[0].push("Projet "+(i+1)+" - Type de projet");
    //     rows[0].push("Projet "+(i+1)+" - Pièce unique ou collection");
    //     rows[0].push("Projet "+(i+1)+" - Typologie");
    //     rows[0].push("Projet "+(i+1)+" - Typologie précision");
    //     rows[0].push("Projet "+(i+1)+" - Échelle de production");
    //     rows[0].push("Projet "+(i+1)+" - Nom de l'éditeur");
    //     rows[0].push("Projet "+(i+1)+" - Nom du distributeur");
    //     rows[0].push("Projet "+(i+1)+" - Pays de distribution");
    //     rows[0].push("Projet "+(i+1)+" - Adresse du projet");
    //     rows[0].push("Projet "+(i+1)+" - Fabrication française");
    //     rows[0].push("Projet "+(i+1)+" - Médias");
    //     rows[0].push("Projet "+(i+1)+" - Autorisation à communiquer sur les fabricants");
    //     rows[0].push("Projet "+(i+1)+" - Public dans le portfolio");
    //     for(let j=0; j< maxNumberOfFabricants; j++){
    //         rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Nom");
    //         rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Travail réalisé");
    //         rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Contact");
    //         rows[0].push("Projet "+(i+1)+" - Fabricant "+(j+1)+" - Email");
    //     }
    // }

    for(let i=0; i< data.length; i++){
        rows.push([
            data[i].participation?.data?.contact_prenom,
            data[i].participation?.data?.contact_nom,
            data[i].participation?.data?.contact_mail,
            data[i].participation?.data?.contact_telephone,
            data[i].hsCompany.properties?.name,
            valuesToOptions(data[i].participation?.data?.culture_francaise, partageCultureFrancaiseFD100).map(option => option.label).join(", "),
            data[i].hsCompany.properties?.description_courte_fr,
            data[i].hsCompany.properties?.description_courte_en,
            data[i].hsCompany.properties?.address,
            data[i].hsCompany.properties?.zip,
            data[i].hsCompany.properties?.city,
            data[i].hsCompany.properties?.country,
            data[i].hsCompany.properties?.numberofemployees,
            data[i].hsCompany.properties?.annualrevenue,
            data[i].hsCompany.properties?.date_de_creation_de_l_entreprise,
            data[i].hsCompany.properties?.positionnement,
            data[i].hsCompany.properties?.clientele,
            data[i].hsCompany.properties?.website,
            data[i].hsCompany.properties?.compte_instagram,
            data[i].hsCompany.properties?.twitterhandle,
            data[i].hsCompany.properties?.linkedin_company_page,
            data[i].hsCompany.properties?.email_agence_rp,
            data[i].company?.logo ? process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+data[i].company.logo : "",
        ])
        // for(let j=0; j< maxNumberOfProjets; j++){
        //     if(!Array.isArray(data[i].participation?.data?.projets)) {
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         rows[i+1].push("");
        //         for(let k=0; k< maxNumberOfFabricants; k++){
        //             rows[i+1].push("");
        //             rows[i+1].push("");
        //             rows[i+1].push("");
        //             rows[i+1].push("");
        //         }
        //         continue;
        //     };
            
        //     rows[i+1].push(quentinCase(data[i].data?.projets[j]?.name));
        //     rows[i+1].push(data[i].data?.projets[j]?.aboutfr);
        //     rows[i+1].push(data[i].data?.projets[j]?.abouten);

        //     //awards (.awards) and press (.lien_presse) are json encoded arrays
        //     //awards has the fields : title and year, should be displayed as "title (year)"
        //     const awards = data[i].data?.projets[j]?.awards || "[]";
        //     try{
        //         const awardsArray = JSON.parse(awards);
        //         rows[i+1].push(awardsArray.map(award => award.title + " (" + award.year + ")").join(", "));
        //     }catch(e){
        //         console.log("Error parsing awards : ", awards);
        //         console.log("In project : ", data[i].data?.projets[j]);
        //         console.log("In participation : ", data[i].data);
        //     }

        //     //press has the fields : title and url, should be displayed as "title (url)"
        //     const press = data[i].data?.projets[j]?.lien_presse || "[]";
        //     try{
        //         const pressArray = JSON.parse(press);
        //         rows[i+1].push(pressArray.map(press => press.title + " (" + press.url + ")").join(", "));
        //     }catch(e){
        //         console.log("Error parsing press : ", press);
        //         console.log("In project : ", data[i].data?.projets[j]);
        //         console.log("In participation : ", data[i].data);
        //     }

        //     rows[i+1].push(data[i].data?.projets[j]?.year);
        //     rows[i+1].push(data[i].data?.projets[j]?.type);
        //     rows[i+1].push(data[i].data?.projets[j]?.unique_collection);

        //     const typologie = data[i].data?.projets[j]?.type === "objet" ? valuesToOptions(data[i].data?.projets[j]?.typologie, typologieObjetFD100).map(option => option.label).join(", ") : valuesToOptions(data[i].data?.projets[j]?.typologie, tyoplogieEspaceFD100).map(option => option.label).join(", ");
        //     rows[i+1].push(typologie);

        //     const typologiePrecisions = valuesToOptions(data[i].data?.projets[j]?.typologieAssise, typologieAssiseFD100).map(option => option.label).join(", ") ||
        //                                 valuesToOptions(data[i].data?.projets[j]?.typologieLuminaire, typologieLuminaireFD100).map(option => option.label).join(", ") ||
        //                                 valuesToOptions(data[i].data?.projets[j]?.typologieTable, typologieTableFD100).map(option => option.label).join(", ");
        //     rows[i+1].push(typologiePrecisions);

        //     rows[i+1].push(data[i].data?.projets[j]?.echelle_production);
        //     rows[i+1].push(data[i].data?.projets[j]?.editeur);
        //     rows[i+1].push(data[i].data?.projets[j]?.distributeur);
        //     rows[i+1].push(data[i].data?.projets[j]?.pays_distribution);
        //     rows[i+1].push(data[i].data?.projets[j]?.adresse);
        //     rows[i+1].push(data[i].data?.projets[j]?.fabrication_fr);

        //     //medias is an array of objects (not json this time, a real array) where the fields we care about are : fileName, path, and credit
        //     //we should display it as such : "fileName : path (credit : credit)" the path should be prefixed with the media base url and "userfiles/"
        //     const medias = data[i].data?.projets[j]?.medias || [];
        //     rows[i+1].push(medias.map(media => media.fileName + " : " + process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + media.path + " (crdit : " + media.credit + ")").join(", "));

        //     rows[i+1].push(data[i].data?.projets[j]?.communiquer_fabricants);
        //     rows[i+1].push(data[i].data?.projets[j]?.public ?  "Oui" : "Non");
            
        //     const projectFabricants = data[i].data?.projets[j]?.fabricants || "[]"; // fabricants is a json encoded array
        //     try{
        //         const fabricants = JSON.parse(projectFabricants);
        //         for(let k=0; k< maxNumberOfFabricants; k++){
        //             if(k < fabricants.length){
        //                 rows[i+1].push(fabricants[k]?.name);
        //                 rows[i+1].push(fabricants[k]?.work);
        //                 rows[i+1].push(fabricants[k]?.contact);
        //                 rows[i+1].push(fabricants[k]?.email);
        //             }else{
        //                 rows[i+1].push("");
        //                 rows[i+1].push("");
        //                 rows[i+1].push("");
        //                 rows[i+1].push("");
        //             }
        //         }
        //     }catch(e){
        //         console.log("Error parsing fabricants : ", projectFabricants);
        //         console.log("In project : ", data[i].data?.projets[j]);
        //         console.log("In participation : ", data[i].data);
        //     }
        // }
    }

    return rows;
}

function name(jury){
    return jury.email;
}

function juryName(data){
    return data.rating.jury.first_name + " " + data.rating.jury.last_name + " : ";
}

function makeFDJuryRows(data,allJuries,allProjects){

    // let maxNumberOfRatings = 0;
    // for(let i=0; i< data.length; i++){
    //     if(data[i].ratings.length > maxNumberOfRatings){
    //         maxNumberOfRatings = data[i].ratings.length;
    //     }
    // }

    let rows = [];
    rows.push([
        "Nom du projet",
        "Nom de l'entreprise",
    ])

    for(let i=0; i< allJuries.length; i++){
        rows[0].push("Note "+name(allJuries[i]));
        rows[0].push("Coup de Coeur "+name(allJuries[i]));
        // rows[0].push("Art de vivre à la française "+name(allJuries[i]));
        // rows[0].push("Innovation / Durabilité "+name(allJuries[i]));
        rows[0].push("Commentaire "+name(allJuries[i]));
    }

    for(let i=0; i< data.length; i++){
        rows.push([
            quentinCase(allProjects.find(proj => proj.projet.participationId + proj.projet._id === data[i].id).projet.name),
            allProjects.find(proj => proj.projet.participationId + proj.projet._id === data[i].id).user.hsCompany?.properties?.name,
        ])
        for(let j=0; j< allJuries.length; j++){

            // debugger

            let note = allJuries[j].juryNotes.find(note => note.participationId + note.projetId === data[i].id);

            if(!note) {
                rows[i+1].push("");
                rows[i+1].push("");
                // rows[i+1].push("");
                // rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };

            rows[i+1].push(note.stars?.toString() || "");
            rows[i+1].push(note.Coup_de_coeur || "");
            // rows[i+1].push(note.Art_de_vivre_à_la_française || "");
            // rows[i+1].push(note.Innovation_durabilité || "");
            rows[i+1].push(note.commentaire || "");
        }
    }

    console.log(rows)
    return rows;

}

function filterRows(rows){
    for(let i=0; i< rows.length; i++){
        for(let j=0; j< rows[i].length; j++){
            if(rows[i][j] === undefined || rows[i][j] === null){
                rows[i][j] = ""
            }

            //if its an array, join it
            if(Array.isArray(rows[i][j])){
                rows[i][j] = rows[i][j].join(', ')
            }

            // rows[i][j] = rows[i][j].replaceAll(',',' ')
            rows[i][j] = rows[i][j].replaceAll(';',' ')
            rows[i][j] = rows[i][j].replaceAll('\n',' ')
            rows[i][j] = rows[i][j].replaceAll('#',' ')
            // rows[i][j] = rows[i][j].replaceAll('\'',' ')
            rows[i][j] = rows[i][j].replace(/(\r\n|\n|\r|\u2028|\u000d|\u000a|\u2029)/gm, ' ')
            var re = /[\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u037F-\u0383\u038B\u038D\u03A2\u0528-\u0530\u0557\u0558\u0560\u0588\u058B-\u058E\u0590\u05C8-\u05CF\u05EB-\u05EF\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB-\u07FF\u082E\u082F\u083F\u085C\u085D\u085F-\u089F\u08A1\u08AD-\u08E3\u08FF\u0978\u0980\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FC-\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A76-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B55\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0C00\u0C04\u0C0D\u0C11\u0C29\u0C34\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5A-\u0C5F\u0C64\u0C65\u0C70-\u0C77\u0C80\u0C81\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0D01\u0D04\u0D0D\u0D11\u0D3B\u0D3C\u0D45\u0D49\u0D4F-\u0D56\u0D58-\u0D5F\u0D64\u0D65\u0D76-\u0D78\u0D80\u0D81\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E86\u0E89\u0E8B\u0E8C\u0E8E-\u0E93\u0E98\u0EA0\u0EA4\u0EA6\u0EA8\u0EA9\u0EAC\u0EBA\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F5-\u13FF\u169D-\u169F\u16F1-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1878-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191D-\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C80-\u1CBF\u1CC8-\u1CCF\u1CF7-\u1CFF\u1DE7-\u1DFB\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20BB-\u20CF\u20F1-\u20FF\u218A-\u218F\u23F4-\u23FF\u2427-\u243F\u244B-\u245F\u2700\u2B4D-\u2B4F\u2B5A-\u2BFF\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E3C-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u312E-\u3130\u318F\u31BB-\u31BF\u31E4-\u31EF\u321F\u32FF\u4DB6-\u4DBF\u9FCD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA698-\uA69E\uA6F8-\uA6FF\uA78F\uA794-\uA79F\uA7AB-\uA7F7\uA82C-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C5-\uA8CD\uA8DA-\uA8DF\uA8FC-\uA8FF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9E0-\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAA7C-\uAA7F\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F-\uABBF\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE27-\uFE2F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF]/g;
            rows[i][j] = rows[i][j].replace(re, "");
            rows[i][j] = '"' + rows[i][j].replaceAll('"','\'') + '"'
        }
    }
    return rows
}

function removeExemple(string){
    //remove any occurence of "(par exemple ... )" in the string
    return string.replace(/\(par exemple.*\)/g, '');
}

function multiSelectValueAsArray(value){
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    return value;
}

function multiSelectValueToString(value, options) {
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => multiSelectValueAsArray(value).includes(opt.value)).map(opt => removeExemple(opt.label)).join(', ')
}

function makePopASDE24Rows(data){

    let maxNumberOfSDEAProjects = 0;
    for(let i=0; i<data.length; i++){
        if(data[i].participation.data?.projets?.length > maxNumberOfSDEAProjects){
            maxNumberOfSDEAProjects = data[i].participation.data.projets.length;
        }
    }

    var rows = []; 
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Intitulé du poste",
        "Nom de l'entreprise",
        "Profil",
        "Document de présentation de l'entreprise",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Site internet",
        "Chiffre d'affaire",
        "Nombre de salariés",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "adhérent/cotisant",

        "spécialité",
        "spécialité | précisions",
        "profil des sociétés recherché",
        "profil des sociétés recherché | précisions",

        "Artisanat - Type de savoir-faire",
        "Artisanat - Échelle de production",
        "Artisanat - Projets à l'export",
        "Artisanat | précisions",
        "Mobiler - Type de mobilier",
        "Mobiler - Type de matériaux",
        "Mobiler - Échelle de production",
        "Mobiler - Projets à l'export",
        "Mobiler | précisions",

        "Que recherchez-vous - Nouveaux modèles de l'économie circulaire",
        "Que recherchez-vous - Process innovants",
        "Que recherchez-vous - Production locale",
        "Que recherchez-vous - Flexibilité d'usage",
        "Que recherchez-vous | précisions",
        
        "Présentiel",

        "Participant 1 - Nom",
        "Participant 1 - Prénom",
        "Participant 1 - Email",
        "Participant 1 - Téléphone portable",
        "Participant 1 - Téléphone fixe",
        "Participant 1 - Intitulé du poste",

        "Participant 2 - Nom",
        "Participant 2 - Prénom",
        "Participant 2 - Email",
        "Participant 2 - Téléphone portable",
        "Participant 2 - Téléphone fixe",
        "Participant 2 - Intitulé du poste",
    ]];

    for(let i=0; i< maxNumberOfSDEAProjects; i++){
        rows[0].push("Projet "+(i+1)+" - Titre");
        rows[0].push("Projet "+(i+1)+" - Type");
        rows[0].push("Projet "+(i+1)+" - Ville");
        rows[0].push("Projet "+(i+1)+" - Pays");
    }

    for(var i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname,
            data[i].hsProfile.lastname,
            data[i].hsProfile.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.jobtitle,
            data[i].hsCompany?.properties?.name,
            data[i].hsProfile.cat_gories_via,
            data[i].participation.data?.cv,
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.website,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.date_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.adherent,

            multiSelectValueToString(data[i].participation.data?.type_projets, SDE2024MultiSelectOptionsA.archiIntListA('fr')),
            data[i].participation.data?.type_projets_precisions,
            multiSelectValueToString(data[i].participation.data?.criteres, SDE2024MultiSelectOptionsA.critereListA('fr')),
            data[i].participation.data?.criteres_precisions,

            multiSelectValueToString(data[i].participation.data?.artisanatType, SDE2024MultiSelectOptionsA.artisanatTypeA('fr')),
            multiSelectValueToString(data[i].participation.data?.artisanatScale, SDE2024MultiSelectOptionsA.artisanatScaleA('fr')),
            multiSelectValueToString(data[i].participation.data?.artisanatExport, SDE2024MultiSelectOptionsA.artisanatExportA('fr')),
            data[i].participation.data?.artisanat_precisions,
            multiSelectValueToString(data[i].participation.data?.mobilierType, SDE2024MultiSelectOptionsA.mobilierTypeA('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierMaterial, SDE2024MultiSelectOptionsA.mobilierMaterialA('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierScale, SDE2024MultiSelectOptionsA.mobilierScaleA('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierExport, SDE2024MultiSelectOptionsA.mobilierExportA('fr')),
            data[i].participation.data?.mobilier_precisions,

            multiSelectValueToString(data[i].participation.data?.rechercheModel, SDE2024MultiSelectOptionsA.rechercheModelA('fr')),
            multiSelectValueToString(data[i].participation.data?.rechercheProcess, SDE2024MultiSelectOptionsA.rechercheProcessA('fr')),
            multiSelectValueToString(data[i].participation.data?.rechercheProduction, SDE2024MultiSelectOptionsA.rechercheProductionA('fr')),
            multiSelectValueToString(data[i].participation.data?.rechercheFlex, SDE2024MultiSelectOptionsA.rechercheFlexA('fr')),
            data[i].participation.data?.recherche_precisions,
            
            data[i].participation.data?.presentiel,

            data[i].participation.data?.name1,
            data[i].participation.data?.firstname1,
            data[i].participation.data?.email1,
            data[i].participation.data?.mobilephone1,
            data[i].participation.data?.landline1,
            data[i].participation.data?.jobtitle1,

            data[i].participation.data?.name2,
            data[i].participation.data?.firstname2,
            data[i].participation.data?.email2,
            data[i].participation.data?.mobilephone2,
            data[i].participation.data?.landline2,
            data[i].participation.data?.jobtitle2,

        ])
        for(let j=0; j< maxNumberOfSDEAProjects; j++){
            if(!Array.isArray(data[i].participation.data?.projets) || !data[i].participation.data?.projets[j]) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].participation.data?.projets[j]?.title);
            rows[i+1].push(data[i].participation.data?.projets[j]?.type);
            rows[i+1].push(data[i].participation.data?.projets[j]?.city);
            rows[i+1].push(data[i].participation.data?.projets[j]?.country);
        }
    }
    return rows
}

function makePopBSDE24Rows(data, allCompanies){

    let maxNumberOfSDEBProjects = 0;
    for(let i=0; i<data.length; i++){
        if(data[i].participation.data?.projets?.length > maxNumberOfSDEBProjects){
            maxNumberOfSDEBProjects = data[i].participation.data.projets.length;
        }
    }

    let maxNumberOfCandidatures = 0;
    for(let i=0; i<data.length; i++){
        if(data[i].candidatures?.length > maxNumberOfCandidatures){
            maxNumberOfCandidatures = data[i].candidatures.length;
        }
    }

    var rows = []; 
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Intitulé du poste",
        "Nom de l'entreprise",
        "Profil",
        "Document de présentation de l'entreprise",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Site internet",
        "Chiffre d'affaire",
        "Nombre de salariés",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "adhérent/cotisant",

        "Type de projets",

        "Artisanat - Type de savoir-faire",
        "Artisanat - Échelle de production",
        "Artisanat - Projets à l'export",
        "Mobiler - Type de mobilier",
        "Mobiler - Type de matériaux",
        "Mobiler - Échelle de production",
        "Mobiler - Projets à l'export",

        "Critères - Nouveaux modèles de l'économie circulaire",
        "Critères - Process innovants",
        "Critères - Production locale",
        "Critères - Flexibilité d'usage",
        
        "Présentiel",

        "Participant 1 - Nom",
        "Participant 1 - Prénom",
        "Participant 1 - Email",
        "Participant 1 - Téléphone portable",
        "Participant 1 - Téléphone fixe",
        "Participant 1 - Intitulé du poste",

        "Participant 2 - Nom",
        "Participant 2 - Prénom",
        "Participant 2 - Email",
        "Participant 2 - Téléphone portable",
        "Participant 2 - Téléphone fixe",
        "Participant 2 - Intitulé du poste",
    ]];

    for(let i=0; i< maxNumberOfSDEBProjects; i++){
        rows[0].push("Projet "+(i+1)+" - Titre");
        rows[0].push("Projet "+(i+1)+" - Type");
        rows[0].push("Projet "+(i+1)+" - Ville");
        rows[0].push("Projet "+(i+1)+" - Pays");
        rows[0].push("Projet "+(i+1)+" - Description");
        rows[0].push("Projet "+(i+1)+" - Fichiers");
    }

    for(let i=0; i< maxNumberOfCandidatures; i++){
        rows[0].push("Candidature "+(i+1)+" - Entreprise");
        rows[0].push("Candidature "+(i+1)+" - priorité");
    }

    for(var i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname,
            data[i].hsProfile.lastname,
            data[i].hsProfile.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.jobtitle,
            data[i].hsCompany?.properties?.name,
            data[i].hsProfile.cat_gories_via,
            data[i].participation.data?.cv,
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.website,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.date_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.adherent,

            multiSelectValueToString(data[i].participation.data?.type_projets, SDE2024MultiSelectOptionsB.archiIntListB('fr')),

            multiSelectValueToString(data[i].participation.data?.artisanatType, SDE2024MultiSelectOptionsB.artisanatTypeB('fr')),
            multiSelectValueToString(data[i].participation.data?.artisanatScale, SDE2024MultiSelectOptionsB.artisanatScaleB('fr')),
            multiSelectValueToString(data[i].participation.data?.artisanatExport, SDE2024MultiSelectOptionsB.artisanatExportB('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierType, SDE2024MultiSelectOptionsB.mobilierTypeB('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierMaterial, SDE2024MultiSelectOptionsB.mobilierMaterialB('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierScale, SDE2024MultiSelectOptionsB.mobilierScaleB('fr')),
            multiSelectValueToString(data[i].participation.data?.mobilierExport, SDE2024MultiSelectOptionsB.mobilierExportB('fr')),

            multiSelectValueToString(data[i].participation.data?.rechercheModel, SDE2024MultiSelectOptionsB.rechercheModelB('fr')),
            multiSelectValueToString(data[i].participation.data?.rechercheProcess, SDE2024MultiSelectOptionsB.rechercheProcessB('fr')),
            multiSelectValueToString(data[i].participation.data?.rechercheProduction, SDE2024MultiSelectOptionsB.rechercheProductionB('fr')),
            multiSelectValueToString(data[i].participation.data?.rechercheFlex, SDE2024MultiSelectOptionsB.rechercheFlexB('fr')),
            
            data[i].participation.data?.presentiel,

            data[i].participation.data?.name1,
            data[i].participation.data?.firstname1,
            data[i].participation.data?.email1,
            data[i].participation.data?.mobilephone1,
            data[i].participation.data?.landline1,
            data[i].participation.data?.jobtitle1,

            data[i].participation.data?.name2,
            data[i].participation.data?.firstname2,
            data[i].participation.data?.email2,
            data[i].participation.data?.mobilephone2,
            data[i].participation.data?.landline2,
            data[i].participation.data?.jobtitle2,
        ])
        for(let j=0; j< maxNumberOfSDEBProjects; j++){
            if(!Array.isArray(data[i].participation.data?.projets) || !data[i].participation.data?.projets[j]) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].participation.data?.projets[j]?.title);
            rows[i+1].push(data[i].participation.data?.projets[j]?.type);
            rows[i+1].push(data[i].participation.data?.projets[j]?.city);
            rows[i+1].push(data[i].participation.data?.projets[j]?.country);
            rows[i+1].push(data[i].participation.data?.projets[j]?.description);
            rows[i+1].push(data[i].participation.data?.projets[j]?.files?.map(file => process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+file.uploaded_path).join(', '));
        }
        data[i].candidatures = data[i].candidatures.sort((a,b) => a.priorite - b.priorite) || [];
        for(let j=0; j< maxNumberOfCandidatures; j++){
            if(!Array.isArray(data[i].candidatures) || !data[i].candidatures[j]) {
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            function getCompanyName(participationId){
                return allCompanies.find(company => company.participation._id === participationId)?.hsCompany?.properties?.name || "";
            }
            rows[i+1].push(getCompanyName(data[i].candidatures[j]?.participationId));
            rows[i+1].push(data[i].candidatures[j]?.priorite);
        }
    }
    return rows
}

function makePopASDE24RowsDetailed(data){

    let maxNumberOfSDEAProjects = 0;
    for(let i=0; i<data.length; i++){
        if(data[i].participation.data?.projets?.length > maxNumberOfSDEAProjects){
            maxNumberOfSDEAProjects = data[i].participation.data.projets.length;
        }
    }

    var rows = []; 
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Intitulé du poste",
        "Nom de l'entreprise",
        "Profil",
        "Document de présentation de l'entreprise",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Site internet",
        "Chiffre d'affaire",
        "Nombre de salariés",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "adhérent/cotisant",

        "spécialité : Commerce et retail",
        "spécialité : Equipements publics",
        "spécialité : Hôtels, restaurants",
        "spécialité : Résidences privées",
        "spécialité : Scénographie et installation",
        "spécialité : Transport",
        "spécialité : Architecte DPLG",
        "spécialité : Groupe hôtelier / restauration",
        "spécialité : Opérateur de co-working/co-living",
        "spécialité : Promoteur immobilier",
        "spécialité : Space planner",

        "spécialité | précisions",

        "profil des sociétés recherché : Agenceur",
        "profil des sociétés recherché : Artisan d'art/ Haute Facture",
        "profil des sociétés recherché : Editeur de mobilier",
        "profil des sociétés recherché : Fabricant",
        "profil des sociétés recherché : Industriel",
        "profil des sociétés recherché : Autre",

        "profil des sociétés recherché | précisions",

        "Artisanat - Type de savoir-faire : Bois",
        "Artisanat - Type de savoir-faire : Céramique & Plâtre",
        "Artisanat - Type de savoir-faire : Luminaires",
        "Artisanat - Type de savoir-faire : Pierre / Marbre",
        "Artisanat - Type de savoir-faire : Plastique recyclé",
        "Artisanat - Type de savoir-faire : Métaux",
        "Artisanat - Type de savoir-faire : Textile/cuir",
        "Artisanat - Type de savoir-faire : Tapis",
        "Artisanat - Type de savoir-faire : Verre / Cristal",
        "Artisanat - Type de savoir-faire : Autres",

        "Artisanat - Échelle de production : Grande série",
        "Artisanat - Échelle de production : Edition limitée",
        "Artisanat - Échelle de production : Sur-mesure",

        "Artisanat - Projets à l'export : Europe",
        "Artisanat - Projets à l'export : Grand export",
        "Artisanat - Projets à l'export : Je ne recherche pas de projet à l'export",

        "Artisanat | précisions",

        "Mobiler - Type de mobilier : Indoor",
        "Mobiler - Type de mobilier : Outdoor",
        "Mobiler - Type de mobilier : Autres",

        "Mobiler - Type de matériaux : Bois",
        "Mobiler - Type de matériaux : Céramique & Plâtre",
        "Mobiler - Type de matériaux : Luminaires",
        "Mobiler - Type de matériaux : Pierre / Marbre",
        "Mobiler - Type de matériaux : Plastique recyclé",
        "Mobiler - Type de matériaux : Métaux",
        "Mobiler - Type de matériaux : Textile/cuir",
        "Mobiler - Type de matériaux : Tapis",
        "Mobiler - Type de matériaux : Verre / Cristal",
        "Mobiler - Type de matériaux : Autres",

        "Mobiler - Échelle de production : Grande série",
        "Mobiler - Échelle de production : Edition limitée",
        "Mobiler - Échelle de production : Sur-mesure",

        "Mobiler - Projets à l'export : Europe",
        "Mobiler - Projets à l'export : Grand export",
        "Mobiler - Projets à l'export : Je ne recherche pas de projet à l'export",

        "Mobiler | précisions",

        "Que recherchez-vous - Nouveaux modèles de l'économie circulaire : Recyclage (par exemple : fauteuil réalisé à partir de plastiques et mousses recyclés)",
        "Que recherchez-vous - Nouveaux modèles de l'économie circulaire : Réutilisation / Upcycling (par exemple : bureaux fabriqués à partir d’anciennes portes récupérées)",
        "Que recherchez-vous - Nouveaux modèles de l'économie circulaire : Réemploi (par exemple : récupération de lampes ou de canapés, réemployés pour le même usage)",
        "Que recherchez-vous - Nouveaux modèles de l'économie circulaire : Eco-conception, engagements RSE, ESS, labels (par exemple : B Corp™ , EPV ) ou normes spécifiques",
        "Que recherchez-vous - Nouveaux modèles de l'économie circulaire : Je ne recherche pas de nouveaux modèles de l'économie circulaire",

        "Que recherchez-vous - Process innovants : Matériaux éco-innovants (par exemple: matériau à base de drêche de bière, panneaux MDF fabriqués avec une résine naturelle végétale, matériau acoustique en textile recyclé)",
        "Que recherchez-vous - Process innovants : Techniques alternatives (par exemple : production de soie 3D naturelle) & Nouvelles technologies (par exemple : conception-modélisation 3D, impression 3D avec matériaux naturels ou recyclés)",
        "Que recherchez-vous - Process innovants : Je ne recherche pas de process innovants",

        "Que recherchez-vous - Production locale : Fabrication en circuit court (par exemple : savoir-faire locaux, traçabilité)",
        "Que recherchez-vous - Production locale : Artisanat (par exemple : très petites séries ou pièces uniques issues de chutes de matériaux)",
        "Que recherchez-vous - Production locale : Je ne recherche pas de production locale",

        "Que recherchez-vous - Flexibilité d'usage : Location & leasing (par exemple location de mobilier et services associés)",
        "Que recherchez-vous - Flexibilité d'usage : Mobilier multifonctions (par exemple un mobilier évolutif pour enfant)",
        "Que recherchez-vous - Flexibilité d'usage : Je ne recherche pas de flexibilité d'usage",

        "Que recherchez-vous | précisions",
        
        "Présentiel",

        "Participant 1 - Nom",
        "Participant 1 - Prénom",
        "Participant 1 - Email",
        "Participant 1 - Téléphone portable",
        "Participant 1 - Téléphone fixe",
        "Participant 1 - Intitulé du poste",

        "Participant 2 - Nom",
        "Participant 2 - Prénom",
        "Participant 2 - Email",
        "Participant 2 - Téléphone portable",
        "Participant 2 - Téléphone fixe",
        "Participant 2 - Intitulé du poste",
    ]];

    for(let i=0; i< maxNumberOfSDEAProjects; i++){
        rows[0].push("Projet "+(i+1)+" - Titre");
        rows[0].push("Projet "+(i+1)+" - Type");
        rows[0].push("Projet "+(i+1)+" - Ville");
        rows[0].push("Projet "+(i+1)+" - Pays");
    }

    for(var i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname,
            data[i].hsProfile.lastname,
            data[i].hsProfile.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.jobtitle,
            data[i].hsCompany?.properties?.name,
            data[i].hsProfile.cat_gories_via,
            data[i].participation.data?.cv,
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.website,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.date_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.adherent,

            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("comm") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("equip") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("hotel_interieur") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("res_interieur") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("scen_interieur") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("transp") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("dplg") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("groupe") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("res_architecte") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("promot") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("space") ? "oui" : "non",

            data[i].participation.data?.type_projets_precisions,
            
            multiSelectValueAsArray(data[i].participation.data?.criteres).includes("agen") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.criteres).includes("arti") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.criteres).includes("edit") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.criteres).includes("fabr") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.criteres).includes("indus") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.criteres).includes("autre") ? "oui" : "non",

            data[i].participation.data?.criteres_precisions,

            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("bois") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("ceram") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("lumin") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("pierre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("plastique") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("metau") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("texti") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("tapis") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("verre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("autres") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.artisanatScale).includes("grande") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatScale).includes("limit") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatScale).includes("custom") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.artisanatExport).includes("Europe") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatExport).includes("Grand export") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatExport).includes("no export") ? "oui" : "non",

            data[i].participation.data?.artisanat_precisions,

            multiSelectValueAsArray(data[i].participation.data?.mobilierType).includes("indoor") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierType).includes("outdoor") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierType).includes("otro") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("bois") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("ceram") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("lumin") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("pierre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("plastique") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("metau") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("texti") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("tapis") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("verre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("autres") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.mobilierScale).includes("grande") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierScale).includes("limit") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierScale).includes("custom") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.mobilierExport).includes("Europe") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierExport).includes("Grand export") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierExport).includes("no export") ? "oui" : "non",

            data[i].participation.data?.mobilier_precisions,

            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("recy") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("upcy") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("reemp") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("rse") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("no") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.rechercheProcess).includes("eco") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProcess).includes("alt") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProcess).includes("no") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.rechercheProduction).includes("eco") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProduction).includes("alt") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProduction).includes("no") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.rechercheFlex).includes("eco") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheFlex).includes("alt") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheFlex).includes("no") ? "oui" : "non",

            data[i].participation.data?.recherche_precisions,
            
            data[i].participation.data?.presentiel,

            data[i].participation.data?.name1,
            data[i].participation.data?.firstname1,
            data[i].participation.data?.email1,
            data[i].participation.data?.mobilephone1,
            data[i].participation.data?.landline1,
            data[i].participation.data?.jobtitle1,

            data[i].participation.data?.name2,
            data[i].participation.data?.firstname2,
            data[i].participation.data?.email2,
            data[i].participation.data?.mobilephone2,
            data[i].participation.data?.landline2,
            data[i].participation.data?.jobtitle2,

        ])
        for(let j=0; j< maxNumberOfSDEAProjects; j++){
            if(!Array.isArray(data[i].participation.data?.projets) || !data[i].participation.data?.projets[j]) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].participation.data?.projets[j]?.title);
            rows[i+1].push(data[i].participation.data?.projets[j]?.type);
            rows[i+1].push(data[i].participation.data?.projets[j]?.city);
            rows[i+1].push(data[i].participation.data?.projets[j]?.country);
        }
    }
    return rows
}

function makePopBSDE24RowsDetailed(data){

    let maxNumberOfSDEBProjects = 0;
    for(let i=0; i<data.length; i++){
        if(data[i].participation.data?.projets?.length > maxNumberOfSDEBProjects){
            maxNumberOfSDEBProjects = data[i].participation.data.projets.length;
        }
    }

    var rows = []; 
    rows = [[
        "Prenom",
        "Nom",
        "Email",
        "Téléphone portable",
        "Téléphone fixe",
        "Intitulé du poste",
        "Nom de l'entreprise",
        "Profil",
        "Document de présentation de l'entreprise",
        "Adresse postale",
        "Code postal",
        "Ville",
        "Pays",
        "Site internet",
        "Chiffre d'affaire",
        "Nombre de salariés",
        "Année de création de l'entreprise",
        "Positionnement",
        "Clientèle",
        "adhérent/cotisant",

        "Type de projets : Commerce et retail",
        "Type de projets : Equipements publics",
        "Type de projets : Hôtels, restaurants",
        "Type de projets : Résidences privées",
        "Type de projets : Scénographie et installation",
        "Type de projets : Transport",
        "Type de projets : Architecte DPLG",
        "Type de projets : Groupe hôtelier / restauration",
        "Type de projets : Opérateur de co-working/co-living",
        "Type de projets : Promoteur immobilier",
        "Type de projets : Space planner",
        
        "Type de projets | précisions",

        "Artisanat - Type de savoir-faire : Bois",
        "Artisanat - Type de savoir-faire : Céramique & Plâtre",
        "Artisanat - Type de savoir-faire : Luminaires",
        "Artisanat - Type de savoir-faire : Pierre / Marbre",
        "Artisanat - Type de savoir-faire : Plastique recyclé",
        "Artisanat - Type de savoir-faire : Métaux",
        "Artisanat - Type de savoir-faire : Textile/cuir",
        "Artisanat - Type de savoir-faire : Tapis",
        "Artisanat - Type de savoir-faire : Verre / Cristal",
        "Artisanat - Type de savoir-faire : Autres",

        "Artisanat - Échelle de production : Grande série",
        "Artisanat - Échelle de production : Edition limitée",
        "Artisanat - Échelle de production : Sur-mesure",

        "Artisanat - Projets à l'export : Europe",
        "Artisanat - Projets à l'export : Grand export",
        "Artisanat - Projets à l'export : Je ne recherche pas de projet à l'export",

        "Artisanat | précisions",

        "Mobiler - Type de mobilier : Indoor",
        "Mobiler - Type de mobilier : Outdoor",
        "Mobiler - Type de mobilier : Autres",

        "Mobiler - Type de matériaux : Bois",
        "Mobiler - Type de matériaux : Céramique & Plâtre",
        "Mobiler - Type de matériaux : Luminaires",
        "Mobiler - Type de matériaux : Pierre / Marbre",
        "Mobiler - Type de matériaux : Plastique recyclé",
        "Mobiler - Type de matériaux : Métaux",
        "Mobiler - Type de matériaux : Textile/cuir",
        "Mobiler - Type de matériaux : Tapis",
        "Mobiler - Type de matériaux : Verre / Cristal",
        "Mobiler - Type de matériaux : Autres",

        "Mobiler - Échelle de production : Grande série",
        "Mobiler - Échelle de production : Edition limitée",
        "Mobiler - Échelle de production : Sur-mesure",

        "Mobiler - Projets à l'export : Europe",
        "Mobiler - Projets à l'export : Grand export",
        "Mobiler - Projets à l'export : Je ne recherche pas de projet à l'export",

        "Mobiler | précisions",

        "Critères - Nouveaux modèles de l'économie circulaire : Recyclage",
        "Critères - Nouveaux modèles de l'économie circulaire : Réutilisation / Upcycling",
        "Critères - Nouveaux modèles de l'économie circulaire : Réemploi",
        "Critères - Nouveaux modèles de l'économie circulaire : Eco-conception, engagements RSE, ESS, labels",
        "Critères - Nouveaux modèles de l'économie circulaire : Je ne recherche pas de nouveaux modèles de l'économie circulaire",

        "Critères - Process innovants : Matériaux éco-innovants",
        "Critères - Process innovants : Techniques alternatives & Nouvelles technologies",
        "Critères - Process innovants : Je ne propose pas de process innovants",

        "Critères - Production locale : Fabrication en circuit court",
        "Critères - Production locale : Artisanat",
        "Critères - Production locale : Je ne propose pas de production locale",

        "Critères - Flexibilité d'usage : Location & leasing",
        "Critères - Flexibilité d'usage : Mobilier multifonctions",
        "Critères - Flexibilité d'usage : Je ne propose pas de flexibilité d'usage",

        "Critères | précisions",
        
        "Présentiel",

        "Participant 1 - Nom",
        "Participant 1 - Prénom",
        "Participant 1 - Email",
        "Participant 1 - Téléphone portable",
        "Participant 1 - Téléphone fixe",
        "Participant 1 - Intitulé du poste",

        "Participant 2 - Nom",
        "Participant 2 - Prénom",
        "Participant 2 - Email",
        "Participant 2 - Téléphone portable",
        "Participant 2 - Téléphone fixe",
        "Participant 2 - Intitulé du poste",
    ]];

    for(let i=0; i< maxNumberOfSDEBProjects; i++){
        rows[0].push("Projet "+(i+1)+" - Titre");
        rows[0].push("Projet "+(i+1)+" - Type");
        rows[0].push("Projet "+(i+1)+" - Ville");
        rows[0].push("Projet "+(i+1)+" - Pays");
        rows[0].push("Projet "+(i+1)+" - Description");
        rows[0].push("Projet "+(i+1)+" - Fichiers");
    }

    for(var i=0; i< data.length; i++){
        rows.push([
            data[i].hsProfile.firstname,
            data[i].hsProfile.lastname,
            data[i].hsProfile.email,
            data[i].hsProfile.mobilephone,
            data[i].hsProfile.phone,
            data[i].hsProfile.jobtitle,
            data[i].hsCompany?.properties?.name,
            data[i].hsProfile.cat_gories_via,
            data[i].participation.data?.cv,
            data[i].hsProfile.address,
            data[i].hsProfile.zip,
            data[i].hsProfile.city,
            data[i].hsProfile.country,
            data[i].hsProfile.website,
            data[i].hsProfile.chiffre_d_affaire_de_l_entreprise,
            data[i].hsProfile.nombre_de_personnes_dans_l_entreprise,
            data[i].hsProfile.date_de_creation_de_l_entreprise,
            data[i].hsProfile.positionnement,
            data[i].hsProfile.clientele,
            data[i].hsProfile.adherent,

            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("comm") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("equip") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("hotel_interieur") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("res_interieur") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("scen_interieur") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("transp") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("dplg") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("groupe") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("res_architecte") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("promot") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.type_projets).includes("space") ? "oui" : "non",

            data[i].participation.data?.type_projets_precisions,
            
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("bois") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("ceram") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("lumin") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("pierre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("plastique") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("metau") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("texti") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("tapis") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("verre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatType).includes("autres") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.artisanatScale).includes("grande") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatScale).includes("limit") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatScale).includes("custom") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.artisanatExport).includes("Europe") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatExport).includes("Grand export") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.artisanatExport).includes("no export") ? "oui" : "non",

            data[i].participation.data?.artisanat_precisions,

            multiSelectValueAsArray(data[i].participation.data?.mobilierType).includes("indoor") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierType).includes("outdoor") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierType).includes("otro") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("bois") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("ceram") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("lumin") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("pierre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("plastique") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("metau") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("texti") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("tapis") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("verre") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierMaterial).includes("autres") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.mobilierScale).includes("grande") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierScale).includes("limit") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierScale).includes("custom") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.mobilierExport).includes("Europe") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierExport).includes("Grand export") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.mobilierExport).includes("no export") ? "oui" : "non",

            data[i].participation.data?.mobilier_precisions,

            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("recy") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("upcy") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("reemp") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("rse") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheModel).includes("no") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.rechercheProcess).includes("eco") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProcess).includes("alt") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProcess).includes("no") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.rechercheProduction).includes("eco") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProduction).includes("alt") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheProduction).includes("no") ? "oui" : "non",

            multiSelectValueAsArray(data[i].participation.data?.rechercheFlex).includes("eco") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheFlex).includes("alt") ? "oui" : "non",
            multiSelectValueAsArray(data[i].participation.data?.rechercheFlex).includes("no") ? "oui" : "non",

            data[i].participation.data?.recherche_precisions,
            
            data[i].participation.data?.presentiel,

            data[i].participation.data?.name1,
            data[i].participation.data?.firstname1,
            data[i].participation.data?.email1,
            data[i].participation.data?.mobilephone1,
            data[i].participation.data?.landline1,
            data[i].participation.data?.jobtitle1,

            data[i].participation.data?.name2,
            data[i].participation.data?.firstname2,
            data[i].participation.data?.email2,
            data[i].participation.data?.mobilephone2,
            data[i].participation.data?.landline2,
            data[i].participation.data?.jobtitle2,
        ])
        for(let j=0; j< maxNumberOfSDEBProjects; j++){
            if(!Array.isArray(data[i].participation.data?.projets) || !data[i].participation.data?.projets[j]) {
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                rows[i+1].push("");
                continue;
            };
            rows[i+1].push(data[i].participation.data?.projets[j]?.title);
            rows[i+1].push(data[i].participation.data?.projets[j]?.type);
            rows[i+1].push(data[i].participation.data?.projets[j]?.city);
            rows[i+1].push(data[i].participation.data?.projets[j]?.country);
            rows[i+1].push(data[i].participation.data?.projets[j]?.description);
            rows[i+1].push(data[i].participation.data?.projets[j]?.files?.map(file => process.env.REACT_APP_MEDIA_BASE_URL+"userfiles/"+file.uploaded_path).join(', '));
        }
    }
    return rows
}

export const exportCSVPopA = (data, filename) => {
    var rows = filterRows(makePopASDE24Rows(data))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportCSVPopB = (data, filename, allCompanies) => {
    var rows = filterRows(makePopBSDE24Rows(data, allCompanies))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportCSVPopADetailed = (data, filename) => {
    var rows = filterRows(makePopASDE24RowsDetailed(data))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportCSVPopBDetailed = (data, filename, allCompanies) => {
    var rows = filterRows(makePopBSDE24RowsDetailed(data, allCompanies))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportCSVFDCandidats = (data, filename) => {
    var rows = filterRows(makeFDCandidatsRows(data))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportCSVFPreselections = (data, filename) => {
    var rows = filterRows(makeFDCandidatsRows(data))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportCSVFDJurys = (data,allJuries,allProjects, filename) => {
    console.log("data")
    console.log(data)
    console.log("allJuries")
    console.log(allJuries)
    console.log("allProjects")
    console.log(allProjects)

    var rows = filterRows(makeFDJuryRows(data,allJuries,allProjects))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

function makePlanningCompaniesRows(planning,allCompanies,allDesigners) {
    var rows = []
    let firstRow = [""]
    for (let i = 0; i < planning.slots.length; i++) {
        firstRow.push(planning.slots[i].horaire)
    }
    rows.push(firstRow)

    let _allCompanies = allCompanies.sort((a,b) => (a.hsCompany?.properties?.name.toLowerCase() > b.hsCompany?.properties?.name.toLowerCase()) ? 1 : ((b.hsCompany?.properties?.name.toLowerCase() > a.hsCompany?.properties?.name.toLowerCase()) ? -1 : 0))

    for (let i = 0; i < _allCompanies.length; i++) {
        let row = [_allCompanies[i].hsCompany?.properties?.name + " [" + _allCompanies[i].participation.data.numTableOULienZoom + "]"]
        for (let j = 0; j < planning.slots.length; j++) {
            let rdv = planning.data.find(rdv => rdv.participationId === _allCompanies[i].participation._id && rdv.slotId === planning.slots[j].id)
            let designer = rdv && allDesigners.find(designer => designer.participation._id === rdv?.designerParticipationId)
            row.push(designer?.hsCompany?.properties?.name || "---")
        }
        rows.push(row)
    }
    
    return rows
}

function makePlanningDesignersRows(planning,allCompanies,allDesigners){

    function getDesignerRdvCount(designer){
        return planning.slots.filter(slot => planning.data.find(rdv => rdv.designerParticipationId === designer.participation._id && rdv.slotId === slot.id)).length
    }

    var rows = []
    let firstRow = [""]
    for (let i = 0; i < planning.slots.length; i++) {
        firstRow.push(planning.slots[i].horaire)
    }
    rows.push(firstRow)

    let _allDesigners = allDesigners.sort((a,b) => (a.hsCompany?.properties?.name?.toLowerCase() > b.hsCompany?.properties?.name?.toLowerCase()) ? 1 : ((b.hsCompany?.properties?.name?.toLowerCase() > a.hsCompany?.properties?.name?.toLowerCase()) ? -1 : 0))

    for (let i = 0; i < _allDesigners.length; i++) {
        if(getDesignerRdvCount(_allDesigners[i]) === 0) continue
        let row = [_allDesigners[i].hsCompany?.properties?.name + " [" + getDesignerRdvCount(_allDesigners[i]) + " rdvs]"]
        for (let j = 0; j < planning.slots.length; j++) {
            let rdv = planning.data.find(rdv => rdv.designerParticipationId === _allDesigners[i].participation._id && rdv.slotId === planning.slots[j].id)
            let company = rdv && allCompanies.find(company => company.participation._id === rdv?.participationId)
            let cell = company?.hsCompany?.properties?.name || "---";
            if(company){
                cell += " [" + company.participation.data.numTableOULienZoom + "]"
            }
            row.push(cell)
        }
        rows.push(row)
    }
    
    return rows
}

export const exportPlanningCompanies = (planning,allCompanies,allDesigners,filename) => {
    var rows = filterRows(makePlanningCompaniesRows(planning,allCompanies,allDesigners))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

export const exportPlanningDesigners = (planning,allCompanies,allDesigners,filename) => {
    var rows = filterRows(makePlanningDesignersRows(planning,allCompanies,allDesigners))
    var csvContent = "data:text/csv;charset=utf-8," + rows.map(row => row.join(",")).join("\n");
    downloadCSV(csvContent, filename)
}

// //make the string lowercase, and the first letter uppercase
// function quentinCase(string){
//     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
// }

//make the string lowercase, and the first letter of each word uppercase
function quentinCase(string){
    if(!string) return "";
    return string.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
}